import React, { useState, useEffect, useCallback } from "react";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import styles from "./message.module.scss";
import moment from "moment";
import ImageS3 from "../../../components/Images/S3Image";
import { useS3Upload } from "../../../hooks/useS3Upload";

export const InboxCards = ({
  seeker,
  onSelected,
  unreadCount,
  latestMessage,
  isActive,
}) => {
  const [imageSource, setImageSource] = useState("");

  const { getSeekerMedia } = useS3Upload();

  const getS3URL = useCallback(
    async (key) => {
      const uri = await getSeekerMedia(key);
      setImageSource(uri);
    },
    [getSeekerMedia]
  );

  useEffect(() => {
    if (seeker?.profilePic) {
      getS3URL(seeker.profilePic);
    }
  }, [getS3URL, seeker]);

  // const getImage = async () => {
  //   try {
  //     const imageURL = await Storage.get(seeker.profilePic.key, {
  //       bucket: seeker.profilePic.bucket,
  //       region: seeker.profilePic.region,
  //     });
  //     setImageSource(imageURL);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  const selectSeeker = () => {
    onSelected(seeker);
  };

  // useEffect(() => {
  //   if (seeker && seeker.profilePic) {
  //     getImage();
  //   }
  // }, []);

  return (
    <>
      {seeker && (
        <div
          className={`d-flex mt-3 justify-content-between cursor-pointer bg-hover-light p-3 rounded ${
            isActive ? styles["active-conversation"] : ""
          }`}
          onClick={selectSeeker}
        >
          <div className="d-flex">
            {seeker.profilePic !== null ? (
              <ImageS3
                alt="Pic"
                className="img-rounded rounded-circle mr-4"
                photo={imageSource}
                style={{ width: 50, height: 50 }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = toAbsoluteUrl(
                    "/media/routemap-media/false-post.jpg"
                  );
                }}
              />
            ) : (
              <></>
            )}
            <div className="d-flex flex-column justify-content-center">
              <p
                className={`text-bold ${styles.text}`}
                style={{ fontWeight: "bolder" }}
              >
                {seeker.firstName} {seeker.lastName}
              </p>
              <p className={`text-muted font-weight-bold ${styles.text}`}>
                Seeker
              </p>
            </div>
          </div>
          <div className="d-flex flex-column justify-content-end mr-2">
            {latestMessage && (
              <p className={` text-muted font-weight-bold ${styles.text}`}>
                {" "}
                {moment(latestMessage.createdAt).fromNow()}
              </p>
            )}
            <div className="justify-content-end d-flex">
              {unreadCount > 0 && (
                <p className={` ${styles.unread}`}>{unreadCount}</p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
